import React from 'react'
import { Link } from 'gatsby'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './timeline.css';

const datas = require('./timeline.json');
 
const VerticalTimeLine = () => {
  return (
    <VerticalTimeline className="vertical-timeline" layout="1-column-left">
      {datas.map((data, index) => {
        return (
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            contentStyle={{ background: 'rgb(168, 208, 236)', color: '#000' }}
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#000' }}
            key={index}
          >
            <h3 className="vertical-timeline-element-title">{data["date"]}</h3>
            { data["character"] && data["character"].map((char) => {
              return (
                <div className="vertical-box">
                  <p>
                  {char["url"] ? <Link to={char["url"]}><b>{char["name"]}</b></Link> : <b>{char["name"]}</b> }<br/>
                    {char["content"]}
                  </p>
                  { char["supplement"] && <small>{char["supplement"]}</small>}
                </div>
              )
            })}
            { data["school"] && <b className="marjong-battle">学校</b> }
            { data["school"] && data["school"].map((value) => {
              return (
                <div className="vertical-box">
                  <p>
                    {value["url"] ? <Link></Link> : <b>{value["name"]}</b> }<br/>
                    {value["content"]}
                  </p>
                </div>
              )
            })}
            { data["marjong"] && <b className="marjong-battle">対局</b> }
            { data["marjong"] && data["marjong"].map((batle) => {
              return (
                <div className="vertical-box-marjong">
                  <Link to={batle["url"]}>
                    <strong>{batle["name"]}</strong>
                  </Link>
                </div>
              )
            })}
          </VerticalTimelineElement>
        )
      })}
    </VerticalTimeline>
  );
}
 
export default VerticalTimeLine;